import { useEffect, useId, useState } from "react";
import { useNavigationContext } from "./use-navigation-context";

// This uses methods and variables to prevent going back that is located in index.html
export function useDrawerState(): [() => void, () => void, boolean] {
	const [isOpen, setIsOpen] = useState(false);
	const id = useId();
	const navigationContext = useNavigationContext();

	const open = () => {
		navigationContext.openDrawer(id, close);
		setIsOpen(true);
	};

	const close = () => {
		navigationContext.closeDrawer(id);
		setIsOpen(false);
	};

	useEffect(() => {
		return close();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return [open, close, isOpen];
}
